<template>
  <div class="systemDoor">
    <div class="systemDoorBox">
      <el-row>
        <el-col :span="20">数据筛选</el-col>
        <el-col :span="4">
          <el-button type="success" round icon="el-icon-check" size="small" @click="searchData">确 认</el-button>
          <el-button type="info" round icon="el-icon-refresh-left" size="small" @click="clearFilter()">重 置</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="10" class="filter">
        <el-col :span="8">
          <span class="label">门店</span>
          <el-input v-model="filterData.searchTerm" placeholder="检查ID或名称" style="width: auto"></el-input>
        </el-col>
        <el-col :span="8">
          <span class="label">区域</span>
          <el-select class="area" v-model="filterData.region" placeholder="请选择" @change=changeFilter multiple>
            <el-option v-for="item in areaList" :key="item.no" :label="item.name" :value="item.no"></el-option>
          </el-select>
        </el-col>
        <el-col :span="8">
          <span class="label">省份</span>
          <el-select class="area" v-model="filterData.province" placeholder="请选择" multiple @change=changeFilter>
            <el-option v-for="item in provinceList" :key="item.no" :label="item.name" :value="item.no"></el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row :gutter="10" class="filter">
        <el-col :span="8">
          <span class="label">城市</span>
          <el-select class="area" v-model="filterData.city" placeholder="请选择" multiple @change=changeFilter>
            <el-option v-for="item in cityList" :key="item.no" :label="item.name" :value="item.no"></el-option>
          </el-select>
        </el-col>
        <el-col :span="8">
          <span class="label">客户</span>
          <el-select class="area" v-model="filterData.reseller" placeholder="请选择" multiple @change=changeFilter>
            <el-option v-for="item in customerList" :key="item.no" :label="item.name" :value="item.no"></el-option>
          </el-select>
        </el-col>
        <el-col :span="8">
          <span class="label">状态</span>
          <el-select class="area" v-model="filterData.status" placeholder="请选择">
            <el-option v-for="item in statusList" :key="item.no" :label="item.name" :value="item.no"></el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-divider></el-divider>

      <el-row>
        <el-col :span="20">数据列表</el-col>
        <el-col :span="2">
          <input type="file" ref="importFile" @change="importExcel"/>
          <el-button plain round icon="el-icon-upload2" size="small" style="color: #67C23A" @click="$refs.importFile.click()"> 导 入</el-button>
        </el-col>
        <el-col :span="2">
          <el-button plain round icon="el-icon-download" size="small" style="color: #67C23A" @click="exportDoor"> 导 出</el-button>
        </el-col>
      </el-row>

      <el-table style="width: 100%; margin-top: 20px" fit stripe :data="tableData" v-loading="tableLoading" border>
        <el-table-column sortable prop="doorName" label="门店名称"></el-table-column>
        <el-table-column sortable prop="doorNo" label="门店编号" width="130"></el-table-column>
        <!-- <el-table-column sortable prop="posId" label="posId" width="100"></el-table-column> -->
        <el-table-column prop="regionName" label="区域" width="150"></el-table-column>
        <el-table-column prop="cityName" label="城市" width="150"></el-table-column>
        <el-table-column prop="resellerName" label="客户" width="120"></el-table-column>
        <el-table-column prop="concept" label="门店类型" width="120"></el-table-column>
        <!-- <el-table-column prop="hub" label="Hub 标记" :formatter="fmtHub" width="120"></el-table-column> -->
        <el-table-column prop="status" label="状态" :formatter="fmtStatus" width="150"></el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="text" style="color: #606266" icon="el-icon-view" size="mini" @click="seeDetail(scope.row.id)">查看详情</el-button>
            <el-button type="text" v-if="scope.row.status===2" @click="changeStatus(scope.row.id)">启用</el-button>
            <el-button type="text" v-if="scope.row.status===1" @click="changeStatus(scope.row.id)">停用</el-button>
          </template>
        </el-table-column>
      </el-table>
      <footer>
        <el-pagination background layout="prev, pager, next" @current-change="currentChange" :current-page="tableConfig.current" :total="total"></el-pagination>
      </footer>
    </div>
  </div>
</template>
<script>
import md5 from "md5";
import _ from "lodash";

export default {
  name: "SystemDoor",
  data() {
    return {
      filterData: {},
      statusList: [
        {
          no: 1,
          name: "活跃中"
        },
        {
          no: 2,
          name: "已停用"
        },
        {
          no: 3,
          name: "已删除"
        }
      ],
      initialFilterData: {
        region: [], //区域
        city: [], //城市
        reseller: [], //客户
        doorClass: [], //等级
        province: [], //省份
        searchTerm: "" //搜索项
      },
      areaList: [],
      cityList: [],
      customerList: [],
      provinceList: [],
      rankList: [],
      tableData: [], // 列表
      total: 10, // 总数量
      tableConfig: {
        size: 10, // 每页数量
        current: 1, // 当前页码
      },
      tableLoading: false
    }
  },
  mounted() {
    this.getData();
    this.clearFilter();
    this.getOptions();
  },
  methods: {
    async getOptions() {
      let res = await axios.post(oprReqUrl+"door/linkage", _.omit(this.filterData, ['searchTerm']));
      if (res.data.code === 200) {
        const dataList = res.data.data;
        this.areaList = dataList.region;
        this.cityList = dataList.city;
        this.rankList = dataList.doorClass;
        this.customerList = dataList.reseller;
        this.provinceList = dataList.province;
      }
    },
    clearFilter() {
      this.filterData = _.cloneDeep(this.initialFilterData);
      this.getOptions();
    },
    changeFilter() {
      this.getOptions();
    },
    searchData() {
      // 搜索数据
      this.tableConfig.current = 1;
      this.getData();
    },
    async getData() {
      // 获取列表
      this.tableLoading = true;
      const params = _.assign({}, this.tableConfig, this.filterData);
      let res = await axios.post(oprReqUrl+"/door/list", params);
      res = res.data;
      if (res.code === 200) {
        this.tableData = res.data.records || [];
        this.total = res.data.total;
      }
      this.tableLoading = false;
    },
    currentChange(index) {
      // 分页
      this.tableConfig.current = index;
      this.getData();
    },
    seeDetail(id) {
      this.$router.push({path: '/pages/systemDoorDetail', query: {id}});
    },
    async importExcel({target}) {
      let formData = new FormData();
      formData.append("file", target.files[0]);
      let res = await axios.post("door/batchImportDoor", formData);
      if (res.data.code === 200) this.$message.success("导入成功！");
      else this.$message.error("导入失败！");
    },
    async exportDoor() {
      const params = _.assign({}, this.tableConfig, this.filterData);
      axios({
        method: 'post',
        url: 'door/export',
        data: params,
        responseType: 'blob'
      }).then(response => {
        console.log(response);
        let url = window.URL.createObjectURL(new Blob([response.data]))
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', '门店.xls')
        document.body.appendChild(link)
        link.click()
      }).catch((error) => {
      })
    },
    fmtStatus(row, column, cellValue, index) {
      if (cellValue === 1) {
        return "活跃中";
      } else if (cellValue === 2) {
        return "已停用";
      } else if (cellValue === 3) {
        return "已删除";
      }
    },
    async changeStatus(id) {
      let res = await axios.post(oprReqUrl+"door/changeStatus", {id: id});
      if (res.data.code === 200) {
        this.getData();
      }
    },
    fmtHub(row, column, cellValue, index) {
      if (cellValue === true) {
        return "Hub";
      } else if (cellValue === false) {
        return "非 Hub";
      }
    },
  }
};
</script>
<style lang="sass" scoped>
.systemDoor
  min-width: 1050px

  input[type=file]
    display: none

  .systemDoorBox
    padding: 20px

    .title
      color: #6F6F6F
      font-size: 26px
      font-weight: 600
      letter-spacing: 2px
      text-align: center
      margin-bottom: 30px

    .filter
      margin-top: 30px

    .label
      font-size: 14px
      color: #606266

    .table-container
      margin-top: 20px

    footer
      padding-top: 20px
      text-align: right
</style>



// WEBPACK FOOTER //
// src/opr/pages/views/systemDoor.vue